import { __ } from "@wordpress/i18n";
import {
	Button,
	ButtonGroup,
	PanelBody,
	__experimentalBoxControl as BoxControl,
} from "@wordpress/components";
import { useState } from "@wordpress/element";
import { desktop, tablet, mobile } from "@wordpress/icons";

const ResponsiveSpacingControl = ({
	label,
	attributeName,
	attributes,
	setAttributes,
}) => {
	const [device, setDevice] = useState("desktop");

	const attributeNames = {
		desktop: `${attributeName}Desktop`,
		tablet: `${attributeName}Tablet`,
		mobile: `${attributeName}Mobile`,
	};

	const devices = [
		{ name: "desktop", label: __("Desktop", "sfb"), icon: desktop },
		{ name: "tablet", label: __("Tablet", "sfb"), icon: tablet },
		{ name: "mobile", label: __("Mobile", "sfb"), icon: mobile },
	];

	const currentValue = attributes[attributeNames[device]] || {};

	const updateAttribute = (value) => {
		setAttributes({ [attributeNames[device]]: value });
	};

	return (
		<PanelBody title={label} initialOpen={false}>
			<div
				style={{
					display: "flex",
					justifyContent: "flex-end",
					marginBottom: "8px",
				}}
			>
				<ButtonGroup>
					{devices.map(({ name, label, icon }) => (
						<Button
							key={name}
							small
							primary={device === name}
							isPressed={device === name}
							onClick={() => setDevice(name)}
							label={label}
							icon={icon}
						/>
					))}
				</ButtonGroup>
			</div>

			<BoxControl
				label={`Set ${device} ${label.toLowerCase()}`}
				values={currentValue}
				onChange={updateAttribute}
			/>
		</PanelBody>
	);
};

export default ResponsiveSpacingControl;
